"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemesTokensFallback = void 0;
var other_1 = require("../utils/other");
var gradientColors = {
    dark: {
        skeletonGradient: "linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0.09) 0%,\n            rgba(255, 255, 255, 0.08) 6.25%,\n            rgba(255, 255, 255, 0.05) 12.5%,\n            rgba(255, 255, 255, 0.01) 25%,\n            rgba(255, 255, 255, 0.05) 37.5%,\n            rgba(255, 255, 255, 0.08) 43.75%,\n            rgba(255, 255, 255, 0.09) 50%,\n            rgba(255, 255, 255, 0.08) 56.25%,\n            rgba(255, 255, 255, 0.05) 62.5%,\n            rgba(255, 255, 255, 0.01) 75%,\n            rgba(255, 255, 255, 0.05) 87.5%,\n            rgba(255, 255, 255, 0.08) 93.75%,\n            rgba(255, 255, 255, 0.09) 100%\n        )",
        skeletonGradientLighter: "linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0.36) 0%,\n            rgba(255, 255, 255, 0.32) 6.25%,\n            rgba(255, 255, 255, 0.20) 12.5%,\n            rgba(255, 255, 255, 0.04) 25%,\n            rgba(255, 255, 255, 0.20) 37.5%,\n            rgba(255, 255, 255, 0.32) 43.75%,\n            rgba(255, 255, 255, 0.36) 50%,\n            rgba(255, 255, 255, 0.08) 56.25%,\n            rgba(255, 255, 255, 0.20) 62.5%,\n            rgba(255, 255, 255, 0.04) 75%,\n            rgba(255, 255, 255, 0.20) 87.5%,\n            rgba(255, 255, 255, 0.32) 93.75%,\n            rgba(255, 255, 255, 0.36) 100%\n        )",
    },
    light: {
        skeletonGradient: "linear-gradient(\n            90deg,\n            rgba(8, 8, 8, 0.09) 0%,\n            rgba(8, 8, 8, 0.08) 6.25%,\n            rgba(8, 8, 8, 0.05) 12.5%,\n            rgba(8, 8, 8, 0.01) 25%,\n            rgba(8, 8, 8, 0.05) 37.5%,\n            rgba(8, 8, 8, 0.08) 43.75%,\n            rgba(8, 8, 8, 0.09) 50%,\n            rgba(8, 8, 8, 0.08) 56.25%,\n            rgba(8, 8, 8, 0.05) 62.5%,\n            rgba(8, 8, 8, 0.01) 75%,\n            rgba(8, 8, 8, 0.05) 87.5%,\n            rgba(8, 8, 8, 0.08) 93.75%,\n            rgba(8, 8, 8, 0.09) 100%\n        )",
        skeletonGradientLighter: "linear-gradient(\n            90deg,\n            rgba(8, 8, 8, 0.36) 0%,\n            rgba(8, 8, 8, 0.32) 6.25%,\n            rgba(8, 8, 8, 0.20) 12.5%,\n            rgba(8, 8, 8, 0.04) 25%,\n            rgba(8, 8, 8, 0.20) 37.5%,\n            rgba(8, 8, 8, 0.32) 43.75%,\n            rgba(8, 8, 8, 0.36) 50%,\n            rgba(8, 8, 8, 0.08) 56.25%,\n            rgba(8, 8, 8, 0.20) 62.5%,\n            rgba(8, 8, 8, 0.04) 75%,\n            rgba(8, 8, 8, 0.20) 87.5%,\n            rgba(8, 8, 8, 0.32) 93.75%,\n            rgba(8, 8, 8, 0.36) 100%\n        )",
    },
};
var deprecatedColorTokenOnActualToken = {
    whitePrimary: 'onDarkTextPrimary',
    whiteSecondary: 'onDarkTextSecondary',
    whiteTertiary: 'onDarkTextTertiary',
    blackPrimary: 'onLightTextPrimary',
    blackSecondary: 'onLightTextSecondary',
    blackTertiary: 'onLightTextTertiary',
    transparent: 'clear',
    buttonClear: 'clear',
    buttonBlack: 'onLightSurfaceSolidDefault',
    buttonBlackSecondary: 'onLightSurfaceTransparentSecondary',
    // buttonBlackTransparent = 'Чёрная для использования поверх картинок',
    buttonWhite: 'onDarkSurfaceSolidDefault',
    buttonWhiteSecondary: 'onDarkSurfaceTransparentSecondary',
    text: 'textPrimary',
    primary: 'textPrimary',
    secondary: 'textSecondary',
    tertiary: 'textTertiary',
    paragraph: 'textParagraph',
    background: 'backgroundPrimary',
    accent: 'textAccent',
    success: 'textPositive',
    warning: 'textWarning',
    critical: 'textNegative',
    overlay: 'overlaySoft',
    // gradient = 'Градиент для заливки основного фона',
    // gradientDevice = 'Бэкграунд ассистента на девайсах',
    surfaceLiquid01: 'surfaceTransparentPrimary',
    surfaceLiquid02: 'surfaceTransparentSecondary',
    surfaceLiquid03: 'surfaceTransparentTertiary',
    surfaceSolid01: 'surfaceSolidPrimary',
    surfaceSolid02: 'surfaceSolidSecondary',
    surfaceSolid03: 'surfaceSolidTertiary',
    surfaceCard: 'surfaceTransparentCard',
    // buttonPrimary = 'Первичный цвет контролов',
    buttonSecondary: 'surfaceTransparentSecondary',
    buttonAccent: 'textAccent',
    buttonSuccess: 'surfacePositive',
    buttonWarning: 'surfaceWarning',
    buttonCritical: 'surfaceNegative',
    // buttonChecked = 'Цвет зажатого контрола',
    // buttonFocused = 'Цвет рамки фокуса у контрола',
    // speechBubbleSent = 'Цвет фона баблов отправленный сообщений',
    // speechBubbleReceived = 'Цвет фона баблов получнных сообщений',
    // voicePhraseGradient = 'Градиент подсказок о голосовых запросах',
};
var getThemeTokenDataGroupsByName = function (themeTokenDataGroups) {
    return Object.values(themeTokenDataGroups).reduce(function (acc, values) { return (__assign(__assign({}, acc), values)); }, {});
};
var getDeprecatedTokens = function (tokens) {
    // Данный префикс будет удалён на этапе генерации файлов с токенами (values.ts и index.ts)
    var legacyPrefix = 'plasmaColors';
    return Object.entries(deprecatedColorTokenOnActualToken)
        .filter(function (_a) {
        var _ = _a[0], actualName = _a[1];
        return tokens[actualName];
    })
        .reduce(function (acc, _a) {
        var _b;
        var oldName = _a[0], actualName = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b["".concat(legacyPrefix, "-").concat(oldName)] = {
            value: "var(--".concat((0, other_1.toKebab)(actualName), ")"),
            comment: "@deprecated instead use ".concat(actualName),
        }, _b)));
    }, {});
};
var getThemesTokensFallback = function (themesTokenDataGroups, withDeprecated) {
    if (withDeprecated === void 0) { withDeprecated = true; }
    var themeTokenDataGroupsByName = getThemeTokenDataGroupsByName(themesTokenDataGroups);
    return Object.entries(themeTokenDataGroupsByName).reduce(function (tokensWithDeprecated, _a) {
        var _b;
        var themeName = _a[0], tokens = _a[1];
        var deprecatedTokens = withDeprecated ? getDeprecatedTokens(tokens.color || {}) : undefined;
        var _c = gradientColors[themeName.endsWith('dark') ? 'dark' : 'light'], skeletonGradient = _c.skeletonGradient, skeletonGradientLighter = _c.skeletonGradientLighter;
        return __assign(__assign({}, tokensWithDeprecated), (_b = {}, _b[themeName] = {
            color: __assign(__assign(__assign({}, tokens.color), { skeletonGradient: {
                    value: skeletonGradient,
                }, skeletonGradientLighter: {
                    value: skeletonGradientLighter,
                } }), deprecatedTokens),
            shadow: __assign({}, tokens.shadow),
            borderRadius: __assign({}, tokens.borderRadius),
            spacing: __assign({}, tokens.spacing),
        }, _b));
    }, {});
};
exports.getThemesTokensFallback = getThemesTokensFallback;
//# sourceMappingURL=getThemesTokensFallback.js.map